"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLogger = exports.setLoggerName = exports.setLogger = void 0;
const pinomin_1 = __importDefault(require("pinomin"));
let _logger;
let _name = null;
const defaultLogger = (0, pinomin_1.default)({
    base: { pid: (_a = global === null || global === void 0 ? void 0 : global.process) === null || _a === void 0 ? void 0 : _a.pid },
    targets: [{ type: 'console', level: 'info' }],
});
function setLogger(value) {
    _logger = value;
}
exports.setLogger = setLogger;
function setLoggerName(value) {
    _name = value;
}
exports.setLoggerName = setLoggerName;
function getLogger(caller) {
    let res = _logger || defaultLogger;
    if (caller) {
        const props = { caller };
        if (_name) {
            props['name'] = _name;
        }
        res = res.child(props);
    }
    return res;
}
exports.getLogger = getLogger;
